var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.794 3.113-.322.383.322-.383zm1.982 11.418.432.252-.432-.252zm-4.743 3.943-.169-.471.169.47zM3.17 14.437l-.435.247.435-.247zM5.29 3.044.01 5.38l4.662 3.404.617-5.74zM11 1.5a8.5 8.5 0 0 1 5.472 1.996l.644-.765A9.5 9.5 0 0 0 11 .5v1zm5.472 1.996a8.5 8.5 0 0 1 2.903 5.05l.985-.17a9.5 9.5 0 0 0-3.244-5.645l-.644.765zm2.903 5.05a8.5 8.5 0 0 1-1.03 5.734l.863.503a9.5 9.5 0 0 0 1.152-6.408l-.985.171zm-1.03 5.734a8.5 8.5 0 0 1-4.48 3.723l.336.941a9.5 9.5 0 0 0 5.007-4.161l-.864-.503zm-4.48 3.723a8.5 8.5 0 0 1-5.826-.035l-.348.937a9.5 9.5 0 0 0 6.51.04l-.337-.942zm-5.826-.035a8.5 8.5 0 0 1-4.434-3.777l-.87.493a9.5 9.5 0 0 0 4.956 4.221l.348-.937zM3.605 14.19a8.5 8.5 0 0 1-.962-5.745l-.983-.183a9.5 9.5 0 0 0 1.075 6.42l.87-.492zm-.962-5.745A8.499 8.499 0 0 1 3.1 6.863l-.93-.37a9.498 9.498 0 0 0-.51 1.77l.983.183z",
    fill: "var(--color-black)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndon);
export default __webpack_public_path__ + "static/media/undon.352b3d39bddd2f318cdbf6a7dd85b9dc.svg";
export { ForwardRef as ReactComponent };